<template>
    <div class="box">
        <h6 class="is-size-5">{{ translate("page.admin_academy_results.points_for_medals") }}</h6>

        <div class="mb-3">
            <div>
                <Checkbox2 v-model="excludeOneManCategories">
                    {{ translate("page.admin_academy_results.dont_count_one_competitor_categories") }}
                </Checkbox2>
            </div>

            <div>
                <Checkbox2 v-model="excludeOneAcademy">
                    {{ translate("page.admin_academy_results.dont_count_one_team_categories") }}
                </Checkbox2>
            </div>

            <Checkbox2 v-model="useExtendedClassification">
                {{ translate("page.admin_academy_results.use_extended_classification") }}
            </Checkbox2>
        </div>

        <div>
            <div class="field" v-for="(pointsForMedal, key) in pointsForMedals" :key="key">
                <label class="label">
                    {{ translate("page.admin_academy_results.place." + key) }}
                </label>

                <div class="control">
                    <input
                        class="input"
                        type="number"
                        min="0"
                        max="1000"
                        :value="pointsForMedal"
                        @input="updateMedalValue(Number(key), $event.target as HTMLInputElement)"
                    />
                </div>
            </div>

            <span v-if="!addRuleStore.areValidMedalPoints" class="has-text-danger">
                {{ translate("page.admin_academy_results.invalid_medal_points") }}
            </span>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed, onMounted, onUnmounted } from "vue";
    import { translate } from "../../Common/translations";
    import { useAddRuleStore } from "./addRuleStore";
    import Checkbox2 from "../../Common/Checkbox2.vue";
    import { eventBus, SELECTED_CATEGORIES_UPDATE } from "./eventBus";
    import { ScoreForAwardedMedalsRule } from "../../Api/competitorResultsApi";

    const addRuleStore = useAddRuleStore();

    function updateSelectedRuleCandidate() {
        addRuleStore.selectedRule = {
            rule: "scoreForAwardedMedals",
            input: {
                selectedCategories: addRuleStore.selectedCategoriesArray,
                pointsForMedals: pointsForMedals.value,
                excludeOneManCategories: excludeOneManCategories.value,
                excludeOneAcademyCategories: excludeOneAcademy.value,
                useExtendedClassification: useExtendedClassification.value,
            },
        } satisfies ScoreForAwardedMedalsRule;

        addRuleStore.validRule = addRuleStore.selectedRule.input.selectedCategories.length > 0 && addRuleStore.areValidMedalPoints;
    }

    const pointsForMedals = computed(() => addRuleStore.pointsForMedals);

    function updateMedalValue(medalKey: number, inputElement: HTMLInputElement) {
        addRuleStore.updatePointsForMedal(medalKey, inputElement.value);
        updateSelectedRuleCandidate();
    }

    const excludeOneManCategories = computed({
        get: () => addRuleStore.excludeOneManCategories,
        set: value => {
            addRuleStore.excludeOneManCategories = value;
            updateSelectedRuleCandidate();
        },
    });
    const excludeOneAcademy = computed({
        get: () => addRuleStore.excludeOneAcademy,
        set: value => {
            addRuleStore.excludeOneAcademy = value;
            updateSelectedRuleCandidate();
        },
    });
    const useExtendedClassification = computed({
        get() {
            return addRuleStore.useExtendedClassification;
        },
        set(value) {
            addRuleStore.useExtendedClassification = value;
            addRuleStore.togglePointsForMedals();
            updateSelectedRuleCandidate();
        },
    });

    onMounted(() => {
        //Toggling is required when component is mounted because it depends on the state of the main store.
        addRuleStore.togglePointsForMedals();
        updateSelectedRuleCandidate();

        eventBus.$on(SELECTED_CATEGORIES_UPDATE, () => {
            updateSelectedRuleCandidate();
        });
    });

    onUnmounted(() => {
        eventBus.$off(SELECTED_CATEGORIES_UPDATE);
    });
</script>

<style scoped></style>
